<div
  class="mode-tabs"
  [ngClass]="{ 'disabled-area': isDisabled, 'mode-tabs--top': isTop, 'wrap-tab-headers': isWrapTabHeaders }">
  @for (tab of tabs; track tab; let i = $index) {
    <ng-template #tabContent>
      @if (tab.iconName) {
        <sb-icon
          [name]="tab.iconName"
          class="mr-2"
          overrideStyle="duotone"
        [hasColor]="true"></sb-icon>
      }
      <span [innerHTML]="tab.isUntranslated ? tab.label : (tab.label | translate)"></span>
      @if (tab.badge) {
        <div class="badge" [innerHTML]="tab.badge | translate"></div>
      }
    </ng-template>
    @if (isRouted) {
      <div
        routerLinkActive="active"
        #rla="routerLinkActive"
        [ngClass]="{ pointer: !rla, 'disabled-area': tab.isDisabled }"
        [routerLink]="getTabRoute(tab.route)"
        (click)="onClick($event, tab)">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </div>
    }
    @if (!isRouted) {
      <div [ngClass]="{ active: tab.isActive, 'disabled-area': tab.isDisabled }" (click)="click(i)">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </div>
    }
    @if (isWizard && i !== tabs.length - 1) {
      <sb-icon name="arrow-right"></sb-icon>
    }
  }
</div>
